import { OrderParams, View } from './Calculate';
import { CurrentPrice } from '../hooks/useCalculate';

export const defaultCurrentPrice: CurrentPrice = {
  amount: 0,
  balance: 0,
  bonus: 0,
  totalAmount: 0,
  backAmount: 0,
  bonusAmount: 0,
  backBonusAmount: 0,
  discountAmount: 0,
  haveAmount: 0,
  haveBonusAmount: 0,
  leftAmount: 0,
  leftBonusAmount: 0,
  payAmount: 0,
  payBonusAmount: 0,
  monthCount: 1,
  fromDate: '',
  toDate: '',
  discountPercent: 0,
  canBalanceAmount: 0,
  earnBonusPercent: 0,
  earnBonusAmount: 0,
  view: {} as View,
};

export const defaultParamsForCalculation: OrderParams = {
  accountId: '0',
  accountType: 'union',
  ServiceExIDs: [],
};
